import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { UnitService } from '../views/units/services/unit.service';

/**
 * Symmetric twin of {@link canActivateRootUnitGuard}. Prevents
 * navigation to routes that only make sense for non-root units (the
 * move-unit wizard).
 */
export const canActivateNonRootUnitGuard: CanActivateFn = () => {
  const unitService = inject(UnitService);
  const router = inject(Router);

  return toObservable(unitService.currentUnit).pipe(
    filter((unit) => unit !== null),
    take(1),
    map((unit) => {
      if (unit.prevUnitId === null) {
        return router.createUrlTree(['/settings']);
      }
      return true;
    })
  );
};
